import { shallowEqual, useSelector } from 'react-redux';

import { NoteModalContainer } from '../../NoteModalContainer';
import { OfferGroupContainer } from '../OfferGroup';
import { LayoutOfferGroups } from 'shared/components/OfferGroup/LayoutOfferGroups';
import { BlockErrorBoundary } from 'shared/containers/BlockErrorBoundary';
import { FavoritesFoldersContainer } from 'shared/containers/FavoritesFoldersContainer';
import { selectOffers, selectOffersCount } from 'shared/slices';
import { IOfferGroup } from 'shared/types/offers';

export const OfferGroupsContainer = () => {
  const offers = useSelector(selectOffers, shallowEqual);
  const totalCount = useSelector(selectOffersCount, shallowEqual);

  if (!totalCount || !offers || !offers.length) {
    return null;
  }

  return (
    <LayoutOfferGroups>
      {offers.map((offerGroup: IOfferGroup, index: number) => {
        return (
          <OfferGroupContainer
            offerGroup={offerGroup}
            position={index}
            key={`offergroup_${index}_${offerGroup.count}`}
          />
        );
      })}
      <BlockErrorBoundary>
        <FavoritesFoldersContainer />
        <NoteModalContainer />
      </BlockErrorBoundary>
    </LayoutOfferGroups>
  );
};
